"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFetch;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _FetchRootContainer = _interopRequireDefault(require("./FetchRootContainer"));

function useFetch(options) {
  return {
    renderRouterContext: function renderRouterContext(child, renderProps) {
      return _react.default.createElement(_FetchRootContainer.default, (0, _extends2.default)({}, options, {
        routerProps: renderProps
      }), child);
    }
  };
}